export default "__VITE_ASSET__CKPH1LGJ__"